import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Breadcrumb, Form, Result, Spin } from 'antd';
import { SettingOutlined, NotificationOutlined } from "@ant-design/icons";
import get from "lodash/get"

import HeaderSelector from '../../components/notificationSetting/headerSelector';
import { fetchCompanies } from '../../redux/actions/companyActions';
import { fetchNotificationSettings } from '../../redux/actions/notificationActions';
import requireAuth from '../../hocs/requireAuth';
import NotificationForm from '../../components/notificationSetting/NotificationForm';
import { NOTIFICATION_PERMISSION, COMPANY_ADMIN_ROLE_ACCESS } from '../../constants';

const PageBreadcrumb = () => {
  return (
    <Breadcrumb
      style={{ fontSize: "14px" }}
      items={[
        {
          title: <SettingOutlined style={{ fontSize: "16px" }} />,
        },
        {
          title: (
            <>
              <NotificationOutlined style={{ fontSize: "16px" }} />
              <span>Notification</span>
            </>
          ),
        },
        {
          title: "Settings",
        },
      ]}
    />
  );
};

const initialState = {
  company: undefined,
  templateType: undefined,
};

const NotificationSettingScreen = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [filter, setFilters] = useState(initialState);
  const [config, setConfig] = useState(undefined);
  const [showEmpty, setShowEmpty] = useState(false)
  const [notificationSetting, setNotificationSetting] = useState({ data: null, is_loaded: false })
  const dispatch = useDispatch();

  const setinitialCompany = (company) => {
     const hasPermission = find(
        get(company, "feature_permissions", []),
        ['key', NOTIFICATION_PERMISSION]
      );
    
      if (!hasPermission) return;
    setFilters({
      ...filter,
      templateType: undefined,
      company,
    });
    setConfig({
      ...config,
      companies: [company],
      template_types: get(company, "template_access_list"),
    });
    form.setFieldsValue({
      template_type: undefined,
      Company: get(company, "id"),
    });
  };
  const getCompanies = () => {
    setLoading(true);
    dispatch(fetchCompanies())
      .then((result) => {
        if (get(result, "length") === 1) {
          setinitialCompany(result[0]);
        } else {
          setConfig({ companies: result });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const getNotifications = () => {
    setLoading(true);
    dispatch(fetchNotificationSettings(get(filter, "company.id"), { type: get(filter, "templateType") })).then((result) => {
      setNotificationSetting({ data: result || {}, is_loaded: true })
      setLoading(false)
      setShowEmpty(false)
    }).catch(() => {
      setLoading(false)
      setNotificationSetting({ data: {}, is_loaded: false })
      setShowEmpty(true)
    })
  }
  useEffect(() => {
    getCompanies();
  }, []);
  return (
    <div className="pl-2 py-2 h-full flex flex-col">
      <div className="flex flex-row justify-between pb-4">
        <div>
          <PageBreadcrumb />
        </div>
        <div></div>
      </div>
      <div className="h-full rounded-xl overflow-hidden bg-white flex-1 overflow-y-auto scrollbar-hidden pb-5 min-w-full ">
        <Spin spinning={loading}>
          <Form form={form} className="w-full px-8 pt-6">
            <HeaderSelector
              onClick={getNotifications}
              filter={filter}
              setConfig={setConfig}
              setFilters={setFilters}
              form={form}
              config={config}
              setNotificationSetting={setNotificationSetting}
            />
          </Form>
          {get(notificationSetting, "is_loaded") && (
            <div className='w-full px-4 md:px-8 py-6'>
              <NotificationForm initialValues={get(notificationSetting, "data")} filter={filter} getNotifications={getNotifications} />
            </div>
          )}
          {showEmpty && (
            <div>
              <Result
                title={`Notification settings not found...!`}
                subTitle="Please try again with another company."
                status="404"
              />
            </div>
          )}
        </Spin>
      </div>
    </div>
  )
}

export default requireAuth(NotificationSettingScreen, COMPANY_ADMIN_ROLE_ACCESS, NOTIFICATION_PERMISSION)